import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ViewEncapsulation, signal } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { Action } from '../volkswagen.types';
import { ChapterLinkComponent } from './chapter-link.component';
import { InsideImageComponent } from './inside-image.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { MarkdownComponent } from 'ngx-markdown';

@Component({
  selector: 'app-vw-action',
  standalone: true,
  imports: [TranslocoPipe, MarkdownComponent, CommonModule, InsideImageComponent, ChapterLinkComponent],
  template: `
    <div
      class="mt-4 flex max-w-4xl cursor-pointer items-start gap-2 rounded-md p-1 transition-all duration-200"
      [ngClass]="{
        'hover:bg-gray-250 border-gray-400 bg-gray-50': isCompleted,
        'hover:bg-primary-50': !isCompleted,
      }"
      (click)="toggleCompleted()"
      (keydown)="onKeyDown($event)"
      tabindex="0"
      role="button"
      [attr.aria-pressed]="isCompleted">
      <p class="pt-[7px] text-gray-800">
        <i class="pi pi-stop" [ngClass]="{ '!hidden': isCompleted }"></i>
        <i class="pi pi-check-square" [ngClass]="{ '!hidden': !isCompleted }"></i>
      </p>
      <div class="flex items-center" [class.opacity-50]="isCompleted">
        <div class="flex-1">
          @if (data.text) {
            <div class="text-sm" [ngClass]="{ 'text-gray-700': isCompleted, 'text-gray-800': !isCompleted }">
              <markdown>{{ data.text.replaceAll(' **', ' **(').replaceAll('** ', ')** ') }}</markdown>
            </div>
          }

          @for (imageRef of imageReferences(); track $index + imageRef.text) {
            <app-vw-image-relation [data]="imageRef"></app-vw-image-relation>
          }

          @for (link of links(); track $index + link.ziel) {
            <!-- TODO: !!!!!!!!!!!!!!!!!!!! -->
            @if (false && (link.tag === 'qv-kap' || link.tag === 'qv-pos')) {
              <a [href]="'#' + link.ziel" class="block border border-red-500 text-blue-800 hover:underline">
                <i class="pi pi-arrow-right pr-2 !text-[10px]"></i>
                {{ 'documents.vw.seeHere' | transloco }} {{ link.ziel }}
              </a>
            }

            @if (link.tag === 'ext-rl') {
              <app-vw-chapter-link [data]="link"></app-vw-chapter-link>
            }
          }

          <!-- Debug -->
          <!-- <div class="bg-red-50 text-xs">{{ data | json }}</div> -->

          <!-- Logs not handled children - TODO: FIXME: !!!!!!!!!!!!!!!!! -->
          @if (false && otherChildren().length) {
            <div class="mt-2">
              <span class="text-md italic">Not handled children:</span>
              @for (childComponent of otherChildren(); track $index + childComponent.text) {
                <div class="bg-slate-50 text-xs text-violet-800">{{ childComponent | json }}</div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  styles: [
    `
      app-vw-action {
        markdown {
          p {
            margin-bottom: 5px;
          }
        }
      }
    `,
  ],
})
export class ActionComponent extends XMLElementBaseComponent<Action> implements AfterViewInit {
  // Renderable children are:
  // Ref within img {tag: 'im-bild', text: '1', children: []}
  // Link {tag: 'qv-kap', ziel: ''}
  // Link {tag: 'qv-pos', ziel: ''}
  // Link {tag: 'ext-rl', "ext-ziel": "esy.27.1.4", children: [baugrup, ext-titel, rep-num]}

  private imgReferenceTags = ['im-bild'];
  private linkTags = ['qv-kap', 'qv-pos', 'ext-rl'];
  private handledTags = [...this.imgReferenceTags, ...this.linkTags, 'wz'];

  isCompleted = false;
  imageReferences = signal<any[]>([]);
  links = signal<any[]>([]);
  otherChildren = signal<any[]>([]);

  ngAfterViewInit() {
    const imageReferences = this.data?.children?.filter((child) => this.imgReferenceTags.includes(child.tag)) || [];
    this.imageReferences.set(imageReferences);

    const links = this.data?.children?.filter((child) => this.linkTags.includes(child.tag)) || [];
    this.links.set(links);

    const furtherChildren = this.data?.children?.filter((child: any) => !this.handledTags.includes(child.tag)) || [];
    this.otherChildren.set(furtherChildren);
  }

  toggleCompleted() {
    this.isCompleted = !this.isCompleted;
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleCompleted();
    }
  }
}
